import { IComplexKeyValPair } from 'app/interfaces/IComplexKeyValPair';
import { Metamodel } from 'app/model/base/model';
import { RestResourceDataset } from 'app/model/dataset/rest-resource.dataset';
import { DataFlowParameterConfig } from 'app/model/pipeline/data-flow-parameter-config';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { IntegerDataFlowType, StringDataFlowType } from '../dataflow-datatype';
import { DocumentForm } from '../dataflow-source';
import { DataFlowExpression } from '../dataflowexpression';
import { DataFlowDatasetSettings, DatasetFormatType } from './dataflow-dataset-settings';

@Metamodel.model({
    name: adfModelTypeMap.restCall.dataflowSettings
})
export class RestCallSettings extends DataFlowDatasetSettings {
    public requestMethod: DataFlowExpression;
    public requestBody: DataFlowExpression;
    public requestTimeout: DataFlowExpression;
    public requestInterval: DataFlowExpression;
    public requestEntity: DataFlowExpression;
    public additionalHeaders: DataFlowParameterConfig[];
    public paginationRules: DataFlowParameterConfig[];
    public queryParameters: DataFlowParameterConfig[];
    public httpCompressionType: DataFlowExpression;
    public batchSize: DataFlowExpression;
    public documentForm: DataFlowExpression;
    public namespaces: boolean;
    public namespacePrefixes: Array<IComplexKeyValPair<string, string>>;
    public nullValue: string;
    public restDataFormat: 'xml' | 'json';
    public restResponseDataFormat: 'xml' | 'json';
    public dateFormat: string;
    public timestampFormat: string;
    public rowRelativeUrl: DataFlowExpression;
    public skipRowRelativeUrl: DataFlowExpression;

    public includeBody: boolean;
    public includeHeader: boolean;
    public includeStatus: boolean;
    public cache: boolean;
    public responseBodyColName: DataFlowExpression;
    public bodyColumnTypeParameter: string;
    public responseHeaderColName: DataFlowExpression;
    public responseStatusColName: DataFlowExpression;

    public getDatasetType(): string {
        return Metamodel.modelFor(RestResourceDataset).name;
    }

    public getFormat(): DatasetFormatType {
        return DatasetFormatType.RestCall;
    }

    public getSubFormat(): string {
        return undefined;
    }

    public getIconClass(): string {
        return 'i-100x100-REST';
    }

    public initialize(subFormat: string): void {
        this.requestMethod = this.transform.createTemplatableExpression(StringDataFlowType.TYPE, 'GET');
        this.requestBody = this.transform.createTemplatableExpression();
        this.requestTimeout = this.transform.createTemplatableExpression(IntegerDataFlowType.TYPE, '30');
        this.requestInterval = this.transform.createTemplatableExpression(IntegerDataFlowType.TYPE, '0');
        this.requestEntity = this.transform.createTemplatableExpression();
        this.additionalHeaders = [];
        this.paginationRules = [];
        this.queryParameters = [];
        this.httpCompressionType = this.transform.createTemplatableExpression();
        this.batchSize = this.transform.createTemplatableExpression(IntegerDataFlowType.TYPE);
        this.documentForm = this.transform.createTemplatableExpression(StringDataFlowType.TYPE, DocumentForm.documentPerLine);
        this.namespaces = false;
        this.namespacePrefixes = [];
        this.restDataFormat = 'json';
        this.restResponseDataFormat = 'json';
        this.rowRelativeUrl = this.transform.createTemplatableExpression();
        this.skipRowRelativeUrl = this.transform.createTemplatableExpression();

        this.includeBody = true;
        this.includeHeader = true;
        this.includeStatus = true;
        this.responseBodyColName = this.transform.createTemplatableExpression(StringDataFlowType.TYPE, 'body');
        this.responseHeaderColName = this.transform.createTemplatableExpression(StringDataFlowType.TYPE, 'headers');
        this.responseStatusColName = this.transform.createTemplatableExpression(StringDataFlowType.TYPE, 'status');
    }
}
